import React from 'react'
import { Typography, Breadcrumb, Space } from 'antd'
import { HomeOutlined } from '@ant-design/icons'

const { Title } = Typography

interface PageHeaderProps {
  title: string
  breadcrumbs?: Array<{
    title: string
    href?: string
  }>
  extra?: React.ReactNode
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, breadcrumbs, extra }) => {
  return (
    <div className="mb-16">
      {breadcrumbs && breadcrumbs.length > 0 && (
        <Breadcrumb className="mb-16">
          <Breadcrumb.Item href="/">
            <HomeOutlined />
          </Breadcrumb.Item>
          {breadcrumbs.map((item, index) => (
            <Breadcrumb.Item key={index} href={item.href}>
              {item.title}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
      )}
      
      <div className="flex-between">
        <Title level={2} style={{ margin: 0 }}>
          {title}
        </Title>
        {extra && <Space>{extra}</Space>}
      </div>
    </div>
  )
}

export default PageHeader